module.exports = __webpack_public_path__ + "img/antes_despues_280.2df1f1bc.png";